import { formatYears } from '@/utils/dateUtils';

const localeTags = {
    nl: 'nl-NL',
    en: 'en-GB',
    id: 'id-ID',
};

function validDate(value) {
    return typeof value === 'string' && value.trim() !== '' && !value.startsWith('0000');
}

export function formatSeoDate(value, locale = 'nl') {
    if (!validDate(value)) return '';

    const [year, month, day] = value.split('T')[0].split('-');
    if (!month || month === '00') return year;

    const date = new Date(Number(year), Number(month) - 1, day && day !== '00' ? Number(day) : 1);
    if (Number.isNaN(date.getTime())) return year || '';
    const options = day && day !== '00'
        ? { day: 'numeric', month: 'long', year: 'numeric' }
        : { month: 'long', year: 'numeric' };
    return new Intl.DateTimeFormat(localeTags[locale] || localeTags.nl, options).format(date);
}

export function personDisplayName(person) {
    return [person?.firstname, person?.lastname]
        .map(value => String(value || '').trim())
        .filter(Boolean)
        .join(' ');
}

export function personLifespan(person, locale = 'nl') {
    if (!person) return '';
    return formatYears(
        person.birthdatetr,
        person.altbirthdatetr,
        person.deathdatetr,
        person.burialdatetr,
        0,
        locale
    );
}

export function buildPersonBiography(person, locale, translate) {
    if (!person) return [];

    const sentences = [];
    const birthDate = formatSeoDate(validDate(person.birthdatetr) ? person.birthdatetr : person.altbirthdatetr, locale);
    const birthPlace = String(person.birthplace || person.altbirthplace || '').trim();
    const deathDate = formatSeoDate(validDate(person.deathdatetr) ? person.deathdatetr : person.burialdatetr, locale);
    const deathPlace = String(person.deathplace || person.burialplace || '').trim();

    if (birthDate && birthPlace) {
        sentences.push(translate('personPage.prerender.bornDatePlace', { date: birthDate, place: birthPlace }));
    } else if (birthDate) {
        sentences.push(translate('personPage.prerender.bornDate', { date: birthDate }));
    } else if (birthPlace) {
        sentences.push(translate('personPage.prerender.bornPlace', { place: birthPlace }));
    }

    if (deathDate && deathPlace) {
        sentences.push(translate('personPage.prerender.diedDatePlace', { date: deathDate, place: deathPlace }));
    } else if (deathDate) {
        sentences.push(translate('personPage.prerender.diedDate', { date: deathDate }));
    } else if (deathPlace) {
        sentences.push(translate('personPage.prerender.diedPlace', { place: deathPlace }));
    }

    const occupation = String(person.occupations?.[0] || '').trim();
    if (occupation) {
        sentences.push(translate('personPage.prerender.occupation', { occupation }));
    }

    const spouseNames = (person.spouses || []).map(spouse => spouse.name).filter(Boolean);
    if (spouseNames.length === 1) {
        sentences.push(translate('personPage.prerender.spouse', { spouse: spouseNames[0] }));
    } else if (spouseNames.length > 1) {
        sentences.push(translate('personPage.prerender.spouses', { spouses: spouseNames.join(', ') }));
    }

    return sentences;
}
